import React from "react";
import { ISailDatesProps } from "./SailDatesProps";
import { SailDatesContainer } from "./SailDatesHelpers";
import { Table } from "react-bootstrap";
import { Link } from "gatsby";

const SailDates: React.FC<ISailDatesProps> = (props) => {
  return (
    <SailDatesContainer>
      <Table striped bordered hover size="sm">
        <thead>
          <tr>
            <th>Embarkation City</th>
            <th>Embarkation Date</th>
            <th>Disembarkation City</th>
            <th>Disembarkation Date</th>
            <th>View Rooms and Rates</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              {props.relationships.field_city
                ? props.relationships.field_city.name
                : "Embarkation City"}
            </td>
            <td>{props.field_embarkation_date}</td>
            <td>
              {props.relationships.field_disembarkation_city
                ? props.relationships.field_disembarkation_city.name
                : "Disembarkation City"}
            </td>
            <td>{props.field_disembarkation_date}</td>
            <td>
              <Link
                to={
                  props.field_rooms_rates_link
                    ? props.field_rooms_rates_link.url
                    : ""
                }
              >
                {" "}
                Find Rates{" "}
              </Link>
            </td>
          </tr>
        </tbody>
      </Table>
    </SailDatesContainer>
  );
};

export default SailDates;
